var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "29", height: "36", viewBox: "0 0 29 36", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M18.125 0h-14.5A3.608 3.608 0 0 0 .018 3.6L0 32.4C0 34.38 1.613 36 3.607 36h21.768C27.369 36 29 34.38 29 32.4V10.8L18.125 0zm3.625 28.8H7.25v-3.6h14.5v3.6zm0-7.2H7.25V18h14.5v3.6zm-5.438-9V2.7l9.97 9.9h-9.97z", fill: "#EA81B9" })
  );
});